import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import {
  KeyboardArrowRight,
  KeyboardArrowLeft,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material";

const InvoiceDetails = ({
  formData,
  setFormData,
  currentInvoiceIndex,
  totalInvoices,
  onPrev,
  onNext,
  onFirst,
  onLast,
}) => {
  const location = useLocation();

  // Set the default date value to the current date if it's not already set
  useEffect(() => {
    setFormData((prev) => {
      if (!prev.date) {
        const now = new Date();
        const istOffset = 5.5 * 60 * 60 * 1000; 
        const istDate = new Date(now.getTime() + istOffset)
          .toISOString()
          .split("T")[0];

        return {
          ...prev,
          date: istDate,
        };
      }
      return prev;
    });
  }, [setFormData]);

  // Do not consume or clear location.state here to avoid race with parent loader

  return (
    <Col className="sales-form-section">
      <Row>
        {/* <Col xs={12} md={6}>
          <InputField
            label="Terms"
            type="select"
            value={formData.terms}
            name="terms"
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                terms: e.target.value,
              }))
            }
            options={[
              { value: "Cash", label: "Cash" },
              { value: "Credit", label: "Credit" },
            ]}
          />
        </Col> */}
        <Col xs={12} md={12}>
          <div style={{ marginBottom: "0.5rem" }}>
            <div>
              Date: {formData.date || new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" })}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={12}>
          <div style={{ marginBottom: "0.5rem" }}>
            <div>
              Invoice Number: {formData.invoice_number || "Auto-generated"}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              type="button"
              onClick={onFirst}
              disabled={currentInvoiceIndex <= 0}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color: currentInvoiceIndex <= 0 ? "#ccc" : "#a36e29",
                cursor: currentInvoiceIndex <= 0 ? "not-allowed" : "pointer",
                marginRight: 4,
              }}
              title="First"
            >
              <KeyboardDoubleArrowLeft />
            </button>
            <button
              type="button"
              onClick={onPrev}
              disabled={currentInvoiceIndex <= 0}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color: currentInvoiceIndex <= 0 ? "#ccc" : "#a36e29",
                cursor: currentInvoiceIndex <= 0 ? "not-allowed" : "pointer",
                marginRight: 4,
              }}
              title="Previous"
            >
              <KeyboardArrowLeft />
            </button>

            <span
              style={{
                fontSize: 13,
                color: "#888",
                margin: "0 4px",
                minWidth: 40,
                textAlign: "center",
              }}
            >
              {currentInvoiceIndex + 1} / {totalInvoices}
            </span>

            <button
              type="button"
              onClick={onNext}
              disabled={currentInvoiceIndex >= totalInvoices - 1}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color:
                  currentInvoiceIndex >= totalInvoices - 1 ? "#ccc" : "#a36e29",
                cursor:
                  currentInvoiceIndex >= totalInvoices - 1
                    ? "not-allowed"
                    : "pointer",
              }}
              title="Next"
            >
              <KeyboardArrowRight />
            </button>
            <button
              type="button"
              onClick={onLast}
              disabled={currentInvoiceIndex >= totalInvoices - 1}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color:
                  currentInvoiceIndex >= totalInvoices - 1 ? "#ccc" : "#a36e29",
                cursor:
                  currentInvoiceIndex >= totalInvoices - 1
                    ? "not-allowed"
                    : "pointer",
              }}
              title="Last"
            >
              <KeyboardDoubleArrowRight />
            </button>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default InvoiceDetails;
